/** GET — `apiV8nocache` base is already `/api/v8`. */
const FILE_UPLOADS_API_PATH = "/pbis/file-uploads"

/** Normalized upload statuses used by the Upload log UI. */
const UPLOAD_STATUS = Object.freeze({
  PROCESSING: "processing",
  PROCESSED: "processed",
  FAILED: "failed"
})

/** Values the API may send for each normalized status. */
const UPLOAD_STATUS_ALIASES = Object.freeze({
  [UPLOAD_STATUS.PROCESSING]: Object.freeze([
    "processing",
    "in_progress",
    "in-progress",
    "inprogress",
    "in process",
    "status_processing",
    "status_in_process",
    "status_pending",
    "pending",
    "queue",
    "queued",
    "status_in_queued"
  ]),
  [UPLOAD_STATUS.PROCESSED]: Object.freeze([
    "processed",
    "success",
    "completed",
    "complete",
    "status_processed"
  ]),
  [UPLOAD_STATUS.FAILED]: Object.freeze([
    "failed",
    "fail",
    "error",
    "partial",
    "status_failed",
    "status_partial"
  ])
})

/** Module / upload source shown in the Upload log table. */
const UPLOAD_MODULE = Object.freeze({
  AWARD: "award",
  REDEEM: "redeem",
  CORRECTION: "correction"
})

/** Values the API may send for each module. */
const UPLOAD_MODULE_ALIASES = Object.freeze({
  [UPLOAD_MODULE.AWARD]: Object.freeze([
    "award",
    "awards",
    "points_award",
    "point_award",
    "award_points"
  ]),
  [UPLOAD_MODULE.REDEEM]: Object.freeze([
    "redeem",
    "redemption",
    "redemptions",
    "points_redeem",
    "point_redeem",
    "redeem_reward"
  ]),
  [UPLOAD_MODULE.CORRECTION]: Object.freeze([
    "correction",
    "corrections",
    "point_correction",
    "points_correction"
  ])
})

export default {
  FILE_UPLOADS_API_PATH,
  UPLOAD_STATUS,
  UPLOAD_STATUS_ALIASES,
  UPLOAD_MODULE,
  UPLOAD_MODULE_ALIASES
}
